(() => {
  if (window.PinoXoGalleryLoaded) return;
  window.PinoXoGalleryLoaded = true;

  const defaults = {
    dataUrl: "",
    labels: {
      all: "ALL",
      viewProduct: "商品ページへ",
      close: "閉じる",
      previous: "前へ",
      next: "次へ",
      loading: "読み込み中",
      empty: "画像がありません",
      error: "ギャラリーを読み込めませんでした",
      loadMore: "もっと見る"
    }
  };
  const config = window.PinoXoGalleryConfig || {};
  const labels = Object.assign({}, defaults.labels, config.labels || {});
  const categoryLinks = {
    "xof-WJyO": [{ label: "モルタル/ストーンの商品を見る", url: "/collections/モルタル-ストーン" }],
    "xof-Jmad": [{ label: "大理石/漆喰の商品を見る", url: "/collections/大理石-漆喰" }],
    "xof-hGEo": [{ label: "シンプル/単色の商品を見る", url: "/collections/シンプル" }],
    "xof-vsLn": [{ label: "木目/ウッドの商品を見る", url: "/collections/木目-ウッド" }],
    "xof-vxgf": [{ label: "くすみカラーの商品を見る", url: "/collections/くすみカラー" }],
    "xof-NASA": [
      { label: "LL", url: "/collections/ll-sheet" },
      { label: "XL", url: "/collections/xl-size-sheet" }
    ]
  };
  let dataPromise;
  const instances = new Set();
  let resizeFrame = 0;
  let lightbox;

  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (char) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;"
  })[char]);

  const stripHtml = (value) => {
    const node = document.createElement("div");
    node.innerHTML = String(value || "");
    return node.textContent || node.innerText || "";
  };

  const getData = () => {
    if (!dataPromise) {
      dataPromise = fetch(config.dataUrl || defaults.dataUrl, { credentials: "same-origin" }).then((response) => {
        if (!response.ok) throw new Error(`Gallery data ${response.status}`);
        return response.json();
      });
    }
    return dataPromise;
  };

  const breakpoint = () => {
    const width = window.innerWidth;
    if (width <= 576) return "xs";
    if (width <= 768) return "sm";
    if (width <= 992) return "md";
    if (width <= 1199) return "lg";
    return "xl";
  };

  const responsiveSetting = (gallery, key, fallback) => {
    const current = breakpoint();
    const responsive = gallery.responsive || {};
    const value = responsive[current] && responsive[current][key];
    if (value !== undefined) return Number(value);
    if (responsive.xl && responsive.xl[key] !== undefined) return Number(responsive.xl[key]);
    if (responsive.fu && responsive.fu[key] !== undefined) return Number(responsive.fu[key]);
    return fallback;
  };

  const isRealLink = (image) => image.link && image.link !== image.url;
  const isLlXlImage = (image) => (image.categories || []).includes("xof-NASA");

  const decodedLink = (link) => {
    try {
      return decodeURIComponent(String(link || "")).toLowerCase();
    } catch (error) {
      return String(link || "").toLowerCase();
    }
  };

  const linkSize = (link) => {
    const decoded = decodedLink(link);
    if (decoded.includes("/products/ll")) return "LL";
    if (decoded.includes("/products/xl")) return "XL";
    return "";
  };

  const sizeLinks = (instance, image) => {
    const links = {};
    if (!isLlXlImage(image)) return [];
    instance.gallery.images.forEach((candidate) => {
      if (candidate.title !== image.title || !isLlXlImage(candidate) || !isRealLink(candidate)) return;
      const size = linkSize(candidate.link);
      if (size && !links[size]) links[size] = candidate.link;
    });
    return [
      { label: "LL", url: links.LL || "/collections/ll-sheet" },
      { label: "XL", url: links.XL || "/collections/xl-size-sheet" }
    ];
  };

  const productLinks = (instance, image) => {
    if (isLlXlImage(image)) return sizeLinks(instance, image);
    if (!isRealLink(image)) return [];
    return [{ label: labels.viewProduct, url: image.link, newTab: image.linkNewTab }];
  };

  const linkAttributes = (link) => {
    const target = link.newTab ? " target=\"_blank\" rel=\"noopener\"" : "";
    return `href="${escapeHtml(link.url)}"${target}`;
  };

  const linkButtonsMarkup = (links, className) => {
    if (!links.length) return "";
    return `<div class="${className}">${links.map((link) => `<a class="${className}-button" ${linkAttributes(link)}>${escapeHtml(link.label)}</a>`).join("")}</div>`;
  };

  const shopifyImageUrl = (url, size) => {
    if (!url || !url.includes("cdn.shopify.com")) return url;
    const parts = url.split("?");
    const resized = parts[0].replace(/\.(jpe?g|png|webp|gif|heic)$/i, `_${size}x.$1`);
    return parts[1] ? `${resized}?${parts[1]}` : resized;
  };

  const imageMarkup = (image, size) => {
    const alt = image.alt || image.title || "";
    const width = image.width || "";
    const height = image.height || "";
    const src = shopifyImageUrl(image.url, size);
    const srcset = [
      `${shopifyImageUrl(image.url, 500)} 500w`,
      `${shopifyImageUrl(image.url, 900)} 900w`,
      `${shopifyImageUrl(image.url, 1400)} 1400w`
    ].join(", ");
    return `<img class="pino-xo-gallery__image" src="${escapeHtml(src)}" srcset="${escapeHtml(srcset)}" sizes="(max-width: 768px) 50vw, 33vw" width="${escapeHtml(width)}" height="${escapeHtml(height)}" alt="${escapeHtml(alt)}" loading="lazy">`;
  };

  const captionMarkup = (image) => {
    const hasTitle = Boolean(image.title);
    const hasDesc = Boolean(image.description);
    const hasLink = isRealLink(image);
    if (!hasTitle && !hasDesc && !hasLink) return "";
    const target = image.linkNewTab ? " target=\"_blank\" rel=\"noopener\"" : "";
    return `<figcaption class="pino-xo-gallery__caption"><div class="pino-xo-gallery__caption-inner">${hasTitle ? `<p class="pino-xo-gallery__title">${escapeHtml(image.title)}</p>` : ""}${hasDesc ? `<p class="pino-xo-gallery__description-text">${escapeHtml(stripHtml(image.description))}</p>` : ""}${hasLink ? `<a class="pino-xo-gallery__product-link" href="${escapeHtml(image.link)}"${target}>${escapeHtml(labels.viewProduct)}</a>` : ""}</div></figcaption>`;
  };

  const itemMarkup = (image, index, style, interactive) => {
    const role = interactive ? " role=\"button\" tabindex=\"0\"" : "";
    const categories = (image.categories || []).join(" ");
    return `<figure class="pino-xo-gallery__item" data-pino-index="${index}" data-pino-categories="${escapeHtml(categories)}"${role}${style ? ` style="${style}"` : ""}><span class="pino-xo-gallery__media">${imageMarkup(image, 900)}${captionMarkup(image)}</span></figure>`;
  };

  const filteredImages = (instance) => {
    if (instance.activeCategory === "all") return instance.gallery.images;
    return instance.gallery.images.filter((image) => (image.categories || []).includes(instance.activeCategory));
  };

  const setCssVars = (instance) => {
    const gallery = instance.gallery;
    const gap = responsiveSetting(gallery, "gutter", 12);
    const cols = responsiveSetting(gallery, "col", 4);
    instance.root.style.setProperty("--pino-xo-gap", `${gap}px`);
    instance.root.style.setProperty("--pino-xo-columns", cols);
    return { gap, cols };
  };

  const renderMasonry = (instance, images) => {
    const popupEnabled = Boolean(instance.gallery.popup && instance.gallery.popup.enabled);
    instance.grid.className = "pino-xo-gallery__masonry";
    instance.grid.innerHTML = images.map((image, index) => itemMarkup(image, index, "", popupEnabled || Boolean(isRealLink(image)))).join("");
  };

  const renderJustified = (instance, images) => {
    const { gap } = setCssVars(instance);
    const width = instance.grid.clientWidth || instance.root.clientWidth || 1200;
    const targetHeight = responsiveSetting(instance.gallery, "height", 360);
    const rows = [];
    let row = [];
    let ratio = 0;
    images.forEach((image, index) => {
      const aspect = image.width && image.height ? image.width / image.height : 1;
      row.push({ image, index, aspect });
      ratio += aspect;
      const rowWidth = ratio * targetHeight + gap * Math.max(row.length - 1, 0);
      if (rowWidth >= width && row.length > 1) {
        rows.push({ items: row, ratio });
        row = [];
        ratio = 0;
      }
    });
    if (row.length) rows.push({ items: row, ratio, last: true });
    instance.grid.className = "pino-xo-gallery__justified";
    instance.grid.innerHTML = rows.map((rowData) => {
      const rowGap = gap * Math.max(rowData.items.length - 1, 0);
      let height = (width - rowGap) / rowData.ratio;
      if (rowData.last) height = Math.min(height, targetHeight);
      height = Math.max(120, Math.min(height, targetHeight));
      return `<div class="pino-xo-gallery__row">${rowData.items.map(({ image, index, aspect }) => {
        const itemWidth = Math.max(90, height * aspect);
        const popupEnabled = Boolean(instance.gallery.popup && instance.gallery.popup.enabled);
        return itemMarkup(image, index, `--pino-xo-item-width:${itemWidth}px;--pino-xo-item-height:${height}px;`, popupEnabled || Boolean(isRealLink(image)));
      }).join("")}</div>`;
    }).join("");
  };

  const updateLoadMore = (instance, total) => {
    const loadMore = instance.gallery.loadMore || {};
    const shouldShow = loadMore.enabled && instance.visibleCount < total;
    instance.actions.innerHTML = shouldShow ? `<button type="button" class="pino-xo-gallery__load-more">${escapeHtml(loadMore.buttonText || labels.loadMore || "もっと見る")}</button>` : "";
  };

  const renderItems = (instance) => {
    setCssVars(instance);
    const allImages = filteredImages(instance);
    instance.currentImages = allImages.slice(0, instance.visibleCount);
    if (!instance.currentImages.length) {
      instance.grid.className = "";
      instance.grid.innerHTML = `<div class="pino-xo-gallery__empty">${escapeHtml(labels.empty)}</div>`;
      updateLoadMore(instance, 0);
      return;
    }
    if (instance.gallery.layout === "justified") renderJustified(instance, instance.currentImages);
    else renderMasonry(instance, instance.currentImages);
    updateLoadMore(instance, allImages.length);
  };

  const renderFilters = (instance) => {
    const filter = instance.gallery.filters || {};
    if (!filter.enabled || !filter.items || !filter.items.length) return "";
    const buttons = [{ id: "all", label: labels.all }, ...filter.items].map((item) => {
      const active = item.id === instance.activeCategory ? " is-active" : "";
      return `<button type="button" class="pino-xo-gallery__filter${active}" data-pino-filter="${escapeHtml(item.id)}">${escapeHtml(item.label || labels.all)}</button>`;
    }).join("");
    return `<div class="pino-xo-gallery__filters" role="list">${buttons}</div>`;
  };

  const renderChrome = (instance) => {
    const showDescription = instance.root.dataset.showDescription !== "false";
    const description = showDescription && instance.gallery.descriptionHtml ? `<div class="pino-xo-gallery__description">${instance.gallery.descriptionHtml}</div>` : "";
    instance.root.innerHTML = `${description}${renderFilters(instance)}${renderCategoryLinks(instance)}<div class="pino-xo-gallery__viewport"><div class="pino-xo-gallery__grid"></div></div><div class="pino-xo-gallery__actions"></div>`;
    instance.grid = instance.root.querySelector(".pino-xo-gallery__grid");
    instance.actions = instance.root.querySelector(".pino-xo-gallery__actions");
    instance.grid.addEventListener("click", (event) => {
      if (event.target.closest("a")) return;
      const item = event.target.closest("[data-pino-index]");
      if (item) activateItem(instance, Number(item.dataset.pinoIndex));
    });
    instance.grid.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      const item = event.target.closest("[data-pino-index]");
      if (!item) return;
      event.preventDefault();
      activateItem(instance, Number(item.dataset.pinoIndex));
    });
    instance.root.querySelectorAll("[data-pino-filter]").forEach((button) => {
      button.addEventListener("click", () => {
        instance.activeCategory = button.dataset.pinoFilter;
        instance.visibleCount = firstCount(instance.gallery);
        renderChrome(instance);
        renderItems(instance);
      });
    });
    instance.actions.addEventListener("click", (event) => {
      const button = event.target.closest(".pino-xo-gallery__load-more");
      if (!button) return;
      const loadMore = instance.gallery.loadMore || {};
      instance.visibleCount += Number(loadMore.more || 10);
      renderItems(instance);
    });
  };

  const firstCount = (gallery) => {
    const loadMore = gallery.loadMore || {};
    return loadMore.enabled ? Number(loadMore.first || 10) : gallery.images.length;
  };

  const renderCategoryLinks = (instance) => {
    const links = categoryLinks[instance.activeCategory] || [];
    return linkButtonsMarkup(links, "pino-xo-gallery__category-links");
  };

  const activateItem = (instance, index) => {
    const image = instance.currentImages[index];
    if (!image) return;
    if (instance.gallery.popup && instance.gallery.popup.enabled) {
      openLightbox(instance, index);
      return;
    }
    if (isRealLink(image)) {
      if (image.linkNewTab) window.open(image.link, "_blank", "noopener");
      else window.location.href = image.link;
    }
  };

  const createLightbox = () => {
    if (lightbox) return lightbox;
    const node = document.createElement("div");
    node.className = "pino-xo-gallery-lightbox";
    node.setAttribute("role", "dialog");
    node.setAttribute("aria-modal", "true");
    node.setAttribute("aria-label", labels.close);
    node.innerHTML = `<div class="pino-xo-gallery-lightbox__panel"><button type="button" class="pino-xo-gallery-lightbox__button pino-xo-gallery-lightbox__close" aria-label="${escapeHtml(labels.close)}">×</button><button type="button" class="pino-xo-gallery-lightbox__button pino-xo-gallery-lightbox__prev" aria-label="${escapeHtml(labels.previous)}">‹</button><img class="pino-xo-gallery-lightbox__image" alt=""><button type="button" class="pino-xo-gallery-lightbox__button pino-xo-gallery-lightbox__next" aria-label="${escapeHtml(labels.next)}">›</button><div class="pino-xo-gallery-lightbox__caption"></div></div>`;
    document.body.appendChild(node);
    lightbox = {
      node,
      image: node.querySelector(".pino-xo-gallery-lightbox__image"),
      caption: node.querySelector(".pino-xo-gallery-lightbox__caption"),
      prev: node.querySelector(".pino-xo-gallery-lightbox__prev"),
      next: node.querySelector(".pino-xo-gallery-lightbox__next"),
      close: node.querySelector(".pino-xo-gallery-lightbox__close"),
      instance: null,
      index: 0
    };
    lightbox.close.addEventListener("click", closeLightbox);
    lightbox.prev.addEventListener("click", () => moveLightbox(-1));
    lightbox.next.addEventListener("click", () => moveLightbox(1));
    node.addEventListener("click", (event) => {
      if (event.target === node) closeLightbox();
    });
    document.addEventListener("keydown", (event) => {
      if (!lightbox.node.classList.contains("is-open")) return;
      if (event.key === "Escape") closeLightbox();
      if (event.key === "ArrowLeft") moveLightbox(-1);
      if (event.key === "ArrowRight") moveLightbox(1);
    });
    return lightbox;
  };

  const updateLightbox = () => {
    const image = lightbox.instance.currentImages[lightbox.index];
    if (!image) return;
    lightbox.image.src = shopifyImageUrl(image.url, 1800);
    lightbox.image.alt = image.alt || image.title || "";
    const links = productLinks(lightbox.instance, image);
    lightbox.caption.innerHTML = `${image.title ? `<p class="pino-xo-gallery-lightbox__title">${escapeHtml(image.title)}</p>` : ""}${linkButtonsMarkup(links, "pino-xo-gallery-lightbox__links")}`;
    lightbox.prev.hidden = lightbox.instance.currentImages.length < 2;
    lightbox.next.hidden = lightbox.instance.currentImages.length < 2;
  };

  const openLightbox = (instance, index) => {
    createLightbox();
    lightbox.instance = instance;
    lightbox.index = index;
    updateLightbox();
    document.body.classList.add("pino-xo-gallery-lightbox-open");
    lightbox.node.classList.add("is-open");
    lightbox.close.focus();
  };

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.node.classList.remove("is-open");
    document.body.classList.remove("pino-xo-gallery-lightbox-open");
  };

  const moveLightbox = (direction) => {
    if (!lightbox || !lightbox.instance) return;
    const length = lightbox.instance.currentImages.length;
    lightbox.index = (lightbox.index + direction + length) % length;
    updateLightbox();
  };

  const initElement = async (root, id) => {
    if (!id || root.dataset.pinoReady === "true") return;
    root.dataset.pinoReady = "true";
    root.classList.add("pino-xo-gallery");
    root.innerHTML = `<div class="pino-xo-gallery__loading">${escapeHtml(labels.loading)}</div>`;
    try {
      const data = await getData();
      const gallery = data.galleries && data.galleries[String(id)];
      if (!gallery) throw new Error(`Unknown gallery ${id}`);
      const instance = {
        root,
        gallery,
        activeCategory: "all",
        visibleCount: firstCount(gallery),
        currentImages: [],
        grid: null,
        actions: null
      };
      instances.add(instance);
      renderChrome(instance);
      renderItems(instance);
    } catch (error) {
      root.innerHTML = `<div class="pino-xo-gallery__error">${escapeHtml(labels.error)}</div>`;
    }
  };

  const init = () => {
    document.querySelectorAll("[data-pino-gallery]").forEach((root) => {
      initElement(root, root.dataset.galleryId);
    });
  };

  window.addEventListener("resize", () => {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(() => {
      instances.forEach(renderItems);
    });
  });

  document.addEventListener("shopify:section:load", init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
